import { cn } from '@/lib/misc/Utils'

export type UserAvatarSize = 'sm' | 'md' | 'lg'
export type UserAvatarTone = 'accent' | 'neutral' | 'inverted'

interface UserAvatarProps {
  initials: string
  size?: UserAvatarSize
  tone?: UserAvatarTone
  className?: string
}

const SIZES: Record<UserAvatarSize, string> = {
  sm: 'size-7 text-2xs',
  md: 'size-8 text-2xs',
  lg: 'size-10 text-sm',
}

const TONES: Record<UserAvatarTone, string> = {
  accent: 'bg-accent-20 text-accent-60',
  neutral: 'bg-neutral-10 text-neutral-70',
  inverted: 'bg-surface/20 text-white',
}

const UserAvatar = ({
  initials,
  size = 'md',
  tone = 'accent',
  className,
}: UserAvatarProps) => (
  <span
    aria-hidden="true"
    className={cn(
      'flex shrink-0 items-center justify-center rounded-full font-semibold leading-none',
      SIZES[size],
      TONES[tone],
      className
    )}
  >
    {initials}
  </span>
)

export default UserAvatar
